import { render, staticRenderFns } from "./ReportNewPage.vue?vue&type=template&id=1f144d8f&"
import script from "./ReportNewPage.vue?vue&type=script&lang=ts&"
export * from "./ReportNewPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports